"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewManageBooking = function NewManageBooking() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.5 10.0001V8.50012H7.5V10.0001H0.5ZM0.5 6.0001V4.50012H11.5V6.0001H0.5ZM0.5\n2.0001V0.500122H11.5V2.0001H0.5ZM9.11538 15.5001V12.8578L14.5442 7.45395C14.6686 7.3296 14.8028\n7.2421 14.947 7.19145C15.0911 7.14081 15.2353 7.1155 15.3795 7.1155C15.5367 7.1155 15.6888 7.14498\n15.8358 7.20395C15.9827 7.26293 16.1163 7.35139 16.2365 7.46932L17.1615 8.40395C17.2692 8.5283\n17.3525 8.66291 17.4115 8.80777C17.4705 8.95266 17.5 9.09753 17.5 9.2424C17.5 9.38726 17.473 9.5347\n17.4192 9.6847C17.3653 9.8347 17.2794 9.97187 17.1615 10.0962L11.7577 15.5001H9.11538ZM10.3077\n14.3078H11.2577L14.5038 11.0462L14.0442 10.5712L13.5788 10.102L10.3077 13.3578V14.3078ZM14.0442\n10.5712L13.5788 10.102L14.5038 11.0462L14.0442 10.5712Z",
    fill: "#6E6D71"
  }));
};
var _default = NewManageBooking;
exports.default = _default;